export const isMobileApp = () => {
    const uaString = navigator.userAgent;
    const regexPattern = new RegExp(/MyAtupri\/\d+\.\d+\.\d+/);
    return regexPattern.test(uaString);
};
